import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from 'react';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { ALL_AVAILABLE_ADD_ONS } from 'pricing-pages-lib/constants/AllAvailableAddOns';
import { ALL_SERVICES } from 'pricing-pages-lib/constants/AllAvailableServices';
import { hasPricingAndPurchasingSucceededSelector } from '../../../selectors/LoadingStateSelectors';
import { currentSkuIdForProductSelector } from '../../../selectors/ProductsSelectors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PlanBuilderContext } from '../../../context/PlanBuilderContext';
import { useAppSelector } from '../../../reducers';
import ExpandableChecklist from './ExpandableChecklist';
import { eligibleAddOnSkuIdsSelector, eligibleServiceSkuIdsSelector } from '../../../selectors/RestrictionSelectors';
import { Divider, FlushedTitle } from '../SharedComponents';

const AddonsAndServicesPickerList = ({
  defaultOpen = false,
  showServicesSection = false,
  screen,
  compact = false,
  showLeadingDivider = false
}) => {
  const {
    productConfigurations,
    setProductConfigurations,
    queryParamTerm,
    trackingSource
  } = useContext(PlanBuilderContext);
  const allAddonsAndServicesSkuIds = useAppSelector(state => {
    return [...ALL_AVAILABLE_ADD_ONS, ...ALL_SERVICES].map(apiName => currentSkuIdForProductSelector(state, {
      apiName
    }));
  });
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  const eligibleAddOnsSkuIds = useAppSelector(state => eligibleAddOnSkuIdsSelector(state, {
    selectedProductConfigurations: productConfigurations
  }));
  const eligibleServicesSkuIds = useAppSelector(state => eligibleServiceSkuIdsSelector(state, {
    selectedProductConfigurations: productConfigurations
  }));
  useEffect(() => {
    if (productConfigurations.some(({
      skuId
    }) => allAddonsAndServicesSkuIds.includes(skuId) && !eligibleAddOnsSkuIds.includes(skuId) && !eligibleServicesSkuIds.includes(skuId))) {
      setProductConfigurations(oldProductConfigurations => oldProductConfigurations.filter(({
        skuId
      }) => !allAddonsAndServicesSkuIds.includes(skuId) || eligibleAddOnsSkuIds.includes(skuId) || eligibleServicesSkuIds.includes(skuId)));
    }
  }, [hasPricingAndPurchasingSucceeded, productConfigurations]);

  const updateSelectedSkus = ({
    value,
    skuId,
    apiName,
    previousValue
  }) => {
    const newProductConfigurations = productConfigurations.filter(itemConfig => itemConfig.skuId !== skuId);

    if (value > 0) {
      newProductConfigurations.push(createProductConfig({
        skuId,
        quantity: value
      }));
    }

    setProductConfigurations(newProductConfigurations);
    getUsageTracker().track('planBuilderInteraction', {
      component: 'AddonsAndServicesPickerList',
      action: value > previousValue ? 'added item' : 'removed item',
      skuId,
      productName: apiName,
      screen,
      trackingSource
    });
  };

  const trackAccordionInteraction = (use, isAccordionOpen) => {
    getUsageTracker().track('planBuilderInteraction', {
      component: 'AddonsAndServicesPickerList',
      action: isAccordionOpen ? `opened ${use}` : `closed ${use}`,
      screen,
      trackingSource
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showLeadingDivider && /*#__PURE__*/_jsx(Divider, {
      className: "m-y-7"
    }), /*#__PURE__*/_jsx(ExpandableChecklist, {
      title: /*#__PURE__*/_jsx(FlushedTitle, {
        "aria-level": 3,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.addonsAndServices.addons.title"
        })
      }),
      subtext: /*#__PURE__*/_jsx("div", {
        className: "m-bottom-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.addonsAndServices.addons.text"
        })
      }),
      skuIds: eligibleAddOnsSkuIds,
      use: "addons",
      selectedProductConfigurations: productConfigurations,
      onSelectedChange: updateSelectedSkus,
      trackAccordionInteraction: trackAccordionInteraction,
      defaultOpen: defaultOpen,
      queryParamTerm: queryParamTerm,
      compact: compact
    }), showServicesSection && /*#__PURE__*/_jsx(ExpandableChecklist, {
      title: /*#__PURE__*/_jsx(FlushedTitle, {
        "aria-level": 3,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.addonsAndServices.services.title"
        })
      }),
      subtext: /*#__PURE__*/_jsx("div", {
        className: "m-bottom-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.addonsAndServices.services.text"
        })
      }),
      skuIds: eligibleServicesSkuIds,
      use: "services",
      selectedProductConfigurations: productConfigurations,
      onSelectedChange: updateSelectedSkus,
      trackAccordionInteraction: trackAccordionInteraction,
      defaultOpen: defaultOpen,
      queryParamTerm: queryParamTerm,
      compact: compact
    })]
  });
};

export default AddonsAndServicesPickerList;